import type { IconProps } from '../types/IconProps.ts';
export const ClipboardList: IconProps = {
    name: 'ClipboardList',
    children: [
        `<path d="M8 4H6a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-2" />`,
        `<rect width="8" height="4" x="8" y="2" rx="2" />`,
        `<path d="M12 18h4M12 14h4M12 10h4" />`,
        `<circle cx="8" cy="18" r=".5" />`,
        `<circle cx="8" cy="14" r=".5" />`,
        `<circle cx="8" cy="10" r=".5" />`,
    ]
};